import React from 'react';
import { useParams } from 'react-router-dom';
import { RosterPageV2 } from '../../components/roster';

const TeamRoster: React.FC = () => {
  const { teamId } = useParams<{ teamId: string }>();

  const handleViewDraftBoard = () => {
    // TODO: Implement draft board navigation
    console.log('View draft board clicked');
  };

  return (
    <RosterPageV2
      teamId={parseInt(teamId!)}
      initialWeek={14}
      onViewDraftBoard={handleViewDraftBoard}
    />
  );
};

export default TeamRoster;